/* unplugin-vue-components disabled */import { render } from "./item-saq.vue?vue&type=template&id=3289e1de"
import script from "./item-saq.vue?vue&type=script&lang=js"
export * from "./item-saq.vue?vue&type=script&lang=js"

import "./item-saq.vue?vue&type=style&index=0&id=3289e1de&lang=less&scope=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__